module.exports = __webpack_public_path__ + "media/images/lb/919-bf0858e54b08655a37e94178cf4fd7e3.svg";